export const DP_PAGE = () => "/dp";
export const DP_EMPLOYEES_PAGE = () => "/dp/colaboradores";
export const DP_EMPLOYEE_NEW_PAGE = () => "/dp/colaboradores/novo";
export const DP_EMPLOYEE_PAGE = (id?: string) =>
  id ? `/dp/colaboradores/${id}` : "/dp/colaboradores/:id";
export const DP_EMPLOYEE_EDIT_PAGE = (id?: string) =>
  id ? `/dp/colaboradores/${id}/editar` : "/dp/colaboradores/:id/editar";
export const DP_SETTINGS_PAGE = () => "/dp/cadastros";
export const DP_FGTS_PAGE = () => "/dp/recolhimentos";
export const DP_INSS_PAGE = () => "/dp/recolhimentos/inss";
export const DP_PROCESSES_PAGE = () => "/dp/processos";
export const DP_PROCESS_PAGE = (id?: string) => (id ? `/dp/processos/${id}` : "/dp/processos/:id");
export const DP_EXPIRING_DOCUMENTS_PAGE = () => "/dp/documentos/vencimentos";
export const DP_EXPIRING_PROBATIONS_PAGE = () => "/dp/experiencias";
/** Ficha do colaborador aberta na aba Documentos, com o documento destacado. */
export const DP_EMPLOYEE_DOCUMENT_PAGE = (employeeId: string, documentId: string) =>
  `/dp/colaboradores/${employeeId}?aba=documentos&documento=${documentId}`;
export const DP_VACATIONS_PAGE = () => "/dp/ferias";
export const DP_LEAVES_PAGE = () => "/dp/afastamentos";
export const DP_SENSITIVE_LOGS_PAGE = () => "/dp/afastamentos/acessos";
export const DP_LEAVE_PAGE = (id?: string) => (id ? `/dp/afastamentos/${id}` : "/dp/afastamentos/:id");
/** Ficha do colaborador aberta numa aba (ex.: "ferias", "afastamentos"). */
export const DP_EMPLOYEE_TAB_PAGE = (employeeId: string, tab: string) => `/dp/colaboradores/${employeeId}?aba=${tab}`;
export const DP_PAYROLL_PAGE = () => "/dp/folha";
/** Provisões de 13º, férias, 1/3 e FGTS (feat/dp-provisoes). */
export const DP_PROVISIONS_PAGE = () => "/dp/provisoes";
export const DP_PAYROLL_PERIOD_PAGE = (id?: string) => (id ? `/dp/folha/${id}` : "/dp/folha/:id");
export const DP_PAYROLL_RESULT_PAGE = (periodId?: string, contractId?: string) =>
  periodId && contractId ? `/dp/folha/${periodId}/colaborador/${contractId}` : "/dp/folha/:id/colaborador/:contractId";
export const DP_ROSTERS_PAGE = () => "/dp/escalas";
export const DP_ROSTER_CHANGES_PAGE = () => "/dp/escalas/trocas";
export const DP_TIMESHEETS_PAGE = () => "/dp/ponto";
export const DP_TIMESHEET_PAGE = (contractId?: string, year?: number, month?: number) =>
  contractId && year && month ? `/dp/ponto/${contractId}/${year}/${month}` : "/dp/ponto/:contractId/:year/:month";
export const DP_ADJUSTMENTS_PAGE = () => "/dp/ponto/ajustes";
export const DP_PRESENCE_PAGE = () => "/dp/ponto/hoje";
/** Marcações feitas no quiosque pelo CPF, para o DP conferir (ADR 0031). */
export const DP_FLAGGED_PUNCHES_PAGE = () => "/dp/ponto/conferencia";
